export default [
  {
    name: 'PlansIndex',
    path: '/plans',
    component: () => import('../views/plans/Index.vue'),
  },
];
